export default {
  common: {
    appName: 'ElderCare',
    loading: 'Ładowanie...',
    retry: 'Ponów',
    goBack: 'Strona główna',
    logout: 'Wyloguj',
    save: 'Zapisz',
    cancel: 'Anuluj',
    confirm: 'Potwierdź',
    delete: 'Usuń',
    edit: 'Edytuj',
    search: 'Szukaj',
    weekDays: {
      sun: 'Ndz',
      mon: 'Pon',
      tue: 'Wt',
      wed: 'Śr',
      thu: 'Czw',
      fri: 'Pt',
      sat: 'Sob',
    },
  },
  nav: {
    home: 'Start',
    login: 'Logowanie',
    dashboard: 'Panel',
    health: 'Zdrowie',
    medication: 'Leki',
    sos: 'Nagły wypadek',
    family: 'Rodzina',
    article: 'Artykuły',
    checkin: 'Check-in',
    settings: 'Ustawienia',
    about: 'O nas',
  },
  footer: {
    rights: 'Wszelkie prawa zastrzeżone',
    privacy: 'Polityka prywatności',
    terms: 'Warunki usługi',
  },
  index: {
    hero: {
      title: 'ElderCare - Inteligentny strażnik zdrowia seniorów',
      subtitle: 'Platforma zarządzania zdrowiem dla seniorów, utrzymująca rodziny na bieżąco, a seniorów w zdrowiu',
      cta: 'Rozpocznij',
      learnMore: 'Dowiedz się więcej',
    },
    features: {
      title: 'Główne funkcje',
      health: { title: 'Monitorowanie zdrowia', desc: 'Śledź ciśnienie krwi, cukier i tętno z inteligentnymi alertami' },
      medication: { title: 'Zarządzanie lekami', desc: 'Przypomnienia i sprawdzanie interakcji leków, nigdy więcej pominiętej dawki' },
      sos: { title: 'Wezwanie pomocy', desc: 'SOS jednym dotknięciem, automatyczne powiadomienie rodziny i udostępnienie lokalizacji' },
      family: { title: 'Opieka rodzinna', desc: 'Zdalne monitorowanie, natychmiastowe alerty i udostępnianie danych dla rodzin' },
      article: { title: 'Artykuły zdrowotne', desc: 'Wiarygodna wiedza medyczna i spersonalizowane przewodniki zdrowotne' },
      checkin: { title: 'Codzienny check-in', desc: 'Proste codzienne śledzenie dla zdrowych nawyków' },
    },
    elderly: {
      title: 'Design dla seniorów',
      desc: 'Zaprojektowane dla seniorów: łatwe w użyciu, widzeniu i dotyku',
      font: 'Duże czcionki',
      touch: 'Duże obszary dotykowe',
      contrast: 'Kolory wysokiego kontrastu',
    },
  },
  login: {
    title: 'ElderCare',
    loginTab: 'Logowanie',
    registerTab: 'Rejestracja',
    name: 'Imię',
    email: 'E-mail',
    password: 'Hasło',
    role: 'Jestem',
    elderRole: 'Seniorem',
    familyRole: 'Rodziną',
    bindCode: 'Kod powiązania',
    bindCodeHint: 'Wprowadź kod powiązania z konta seniora, aby połączyć i przeglądać dane zdrowotne',
    loginBtn: 'Zaloguj',
    registerBtn: 'Zarejestruj',
    verifyHint: 'Po rejestracji na Twój adres zostanie wysłany e-mail weryfikacyjny',
    error: 'Operacja nie powiodła się, spróbuj ponownie',
    nameTooShort: 'Imię musi mieć co najmniej 2 znaki',
    emailInvalid: 'Podaj prawidłowy adres e-mail',
    passwordTooShort: 'Hasło musi mieć co najmniej 8 znaków',
  },
  dashboard: {
    title: 'Panel zdrowia',
    metrics: {
      bloodPressure: 'Ciśnienie krwi',
      bloodSugar: 'Cukier we krwi',
      heartRate: 'Tętno',
      weight: 'Waga',
      sleep: 'Sen',
      temperature: 'Temperatura',
    },
    quickActions: 'Szybkie akcje',
    recordHealth: 'Zapisz zdrowie',
    takeMedicine: 'Weź lek',
    sos: 'Wezwanie pomocy',
    checkinStatus: 'Check-in dziś',
    checkedIn: 'Zaznaczono dziś',
    notCheckedIn: 'Nie zaznaczono dziś',
    goCheckin: 'Zaznacz',
    medicationReminders: 'Przypomnienia o lekach',
    noReminders: 'Brak przypomnień o lekach',
    taken: 'Przyjęto',
  },
  health: {
    title: 'Karta zdrowia',
    inputTitle: 'Wprowadzanie danych',
    systolic: 'Skurczowe (mmHg)',
    diastolic: 'Rozkurczowe (mmHg)',
    bloodSugar: 'Cukier (mmol/L)',
    heartRate: 'Tętno (bpm)',
    weight: 'Waga (kg)',
    sleepHours: 'Sen (godziny)',
    temperature: 'Temperatura (°C)',
    submit: 'Wyślij wpis',
    trend: 'Trendy',
    days: 'dni',
    aiAnalysis: 'Analiza zdrowia AI',
    analyze: 'Analizuj',
    noAnalysis: 'Kliknij powyższy przycisk, aby uzyskać raport analizy zdrowia AI',
    history: 'Historia',
    noHistory: 'Brak historii',
    chartLabelSystolic: 'Ciśnienie skurczowe',
  },
  medication: {
    title: 'Zarządzanie lekami',
    currentPlan: 'Obecny plan',
    noMedications: 'Brak leków',
    addMedication: 'Dodaj lek',
    name: 'Nazwa leku',
    dosage: 'Dawkowanie',
    frequency: 'Częstotliwość',
    freqDaily: 'Raz dziennie',
    freqTwice: 'Dwa razy dziennie',
    freqThree: 'Trzy razy dziennie',
    freqWeekly: 'Raz w tygodniu',
    time: 'Czas przyjęcia',
    startDate: 'Data rozpoczęcia',
    addBtn: 'Dodaj',
    interactionWarning: 'Ostrzeżenie o interakcji leków',
    noInteraction: 'Brak ryzyka interakcji leków',
    calendar: 'Kalendarz leków',
    invalidTimeFormat: 'Nieprawidłowy format czasu, użyj HH:mm (np., 08:00, 20:00)',
  },
  sos: {
    title: 'Wezwanie pomocy',
    holdToCall: 'Przytrzymaj aby zadzwonić',
    holdHint: 'Przytrzymaj 1 sekundę, aby aktywować wezwanie pomocy',
    sent: 'Wezwanie pomocy wysłane',
    sentDesc: 'Twoje kontakty awaryjne zostały powiadomione. Zachowaj spokój i czekaj na pomoc',
    contacts: 'Kontakty awaryjne',
    location: 'Obecna lokalizacja',
    loadingLocation: 'Ustalanie lokalizacji...',
    locationUnavailable: 'Lokalizacja niedostępna',
    history: 'Historia SOS',
    noHistory: 'Brak rejestrów SOS',
    confirmed: 'Potwierdzono',
    pending: 'Oczekuje',
  },
  family: {
    title: 'Opieka rodzinna',
    members: 'Powiązana rodzina',
    noMembers: 'Brak powiązanych członków rodziny',
    bindCode: 'Kod powiązania',
    bindCodeHint: 'Udostępnij ten kod rodzinie, aby powiązać konta',
    invite: 'Zaproś rodzinę',
    email: 'E-mail rodziny',
    relationship: 'Relacja',
    relSon: 'Syn',
    relDaughter: 'Córka',
    relSpouse: 'Małżonek',
    relSibling: 'Brat/Siostra',
    relOther: 'Inne',
    inviteBtn: 'Wyślij zaproszenie',
    notifications: 'Preferencje powiadomień',
    prefAbnormal: 'Alert o nieprawidłowościach zdrowotnych',
    prefMedication: 'Przypomnienie o lekach',
    prefSos: 'Alert awaryjny',
    prefWeekly: 'Raport tygodniowy',
    prefCheckin: 'Powiadomienie check-in',
    dataSharing: 'Udostępnianie danych',
    shareDesc: 'Zezwól rodzinie na przeglądanie Twoich danych zdrowotnych',
    inviteSent: 'Zaproszenie wysłane pomyślnie',
    inviteFailed: 'Nie udało się wysłać zaproszenia, spróbuj ponownie',
    invalidEmail: 'Wprowadź prawidłowy adres e-mail',
  },
  article: {
    title: 'Artykuły zdrowotne',
    search: 'Szukaj artykułów...',
    noArticles: 'Nie znaleziono artykułów',
    expand: 'Czytaj więcej',
    collapse: 'Zwiń',
    categories: {
      all: 'Wszystkie',
      heart: 'Układ krążenia',
      diabetes: 'Cukrzyca',
      bone: 'Kości',
      sleep: 'Sen',
      nutrition: 'Odżywianie',
      exercise: 'Ćwiczenia',
    },
  },
  checkin: {
    title: 'Codzienny check-in',
    feeling: 'Jak się czujesz dzisiaj?',
    feelings: {
      great: 'Świetnie',
      good: 'Dobrze',
      normal: 'Normalnie',
      bad: 'Źle',
      terrible: 'Tragicznie',
    },
    medication: 'Leki dziś',
    yes: 'Tak',
    no: 'Nie',
    diet: 'Ocena diety',
    dietRatings: {
      good: 'Dobra',
      normal: 'Normalna',
      poor: 'Słaba',
    },
    exercise: 'Ćwiczenia dziś',
    mood: 'Nastrój',
    submit: 'Wyślij check-in',
    streak: 'Seria',
    streakDays: 'dni',
    calendar: 'Kalendarz check-in',
  },
  settings: {
    title: 'Ustawienia',
    profile: 'Profil',
    name: 'Nazwa użytkownika',
    phone: 'Telefon',
    birthday: 'Data urodzenia',
    emergencyContact: 'Kontakt awaryjny',
    save: 'Zapisz zmiany',
    preferences: 'Preferencje',
    language: 'Język',
    theme: 'Motyw',
    light: 'Jasny',
    dark: 'Ciemny',
    notifications: 'Powiadomienia',
    notifHealth: 'Alerty zdrowotne',
    notifMedication: 'Przypomnienia o lekach',
    notifSos: 'Alerty awaryjne',
    notifCheckin: 'Przypomnienia check-in',
    bindCode: 'Mój kod powiązania',
    changePassword: 'Zmień hasło',
    currentPassword: 'Obecne hasło',
    newPassword: 'Nowe hasło',
    changePasswordBtn: 'Zmień hasło',
    dangerZone: 'Strefa zagrożenia',
    deleteDesc: 'Usunięcie konta jest nieodwracalne. Wszystkie dane zostaną utracone',
    deleteAccount: 'Usuń konto',
    deleteConfirm: 'Czy na pewno? Ta akcja jest nieodwracalna!',
  },
  about: {
    title: 'O ElderCare',
    subtitle: 'Inteligentny strażnik zdrowia seniorów',
    intro: 'Wprowadzenie',
    introContent: 'ElderCare to platforma zdrowotna dla seniorów z inteligentnym monitorowaniem, zarządzaniem lekami, wezwaniami pomocy i wieloma innymi funkcjami, pomagająca seniorom zarządzać zdrowiem pozostając w kontakcie z rodziną.',
    version: 'Informacje o wersji',
    versionNumber: 'Numer wersji',
    buildDate: 'Data kompilacji',
    acknowledgements: 'Podziękowania',
    contact: 'Kontakt',
    contactEmail: "q3300404157{'@'}gmail.com",
    privacy: 'Polityka prywatności',
    terms: 'Warunki usługi',
  },
  notfound: {
    message: 'Przepraszamy, strona której szukasz nie istnieje',
    goHome: 'Strona główna',
  },
  privacy: {
    title: 'Polityka prywatności',
    sections: {
      collection: {
        title: 'Zbieranie informacji',
        content: 'Zbieramy tylko dane osobowe niezbędne do świadczenia usług, w tym dane rejestracyjne (e-mail, imię), dane zdrowotne (ciśnienie krwi, cukier i inne wskaźniki) oraz informacje o urządzeniu. Nie zbieramy danych osobowych niezwiązanych z naszymi usługami.',
      },
      usage: {
        title: 'Wykorzystanie informacji',
        content: 'Twoje dane osobowe są wykorzystywane wyłącznie do świadczenia i poprawy usług, w tym analizy danych zdrowotnych, alertów o nieprawidłowościach, przypomnień o lekach i innych podstawowych funkcji. Nie wykorzystamy Twoich informacji do nieautoryzowanych celów.',
      },
      storage: {
        title: 'Przechowywanie informacji',
        content: 'Twoje dane są przechowywane na bezpiecznych serwerach chmurowych z szyfrowaną transmisją i przechowywaniem. Stosujemy rozsądne środki techniczne w celu ochrony bezpieczeństwa Twoich danych i zapobiegania nieautoryzowanemu dostępowi.',
      },
      sharing: {
        title: 'Udostępnianie informacji',
        content: 'Bez Twojej wyraźnej zgody nie udostępniamy Twoich danych osobowych stronom trzecim. Dane zdrowotne są udostępniane powiązanym członkom rodziny dopiero po Twojej autoryzacji połączenia rodzinnego.',
      },
      rights: {
        title: 'Twoje prawa',
        content: 'Masz prawo dostępu, poprawiania i usuwania swoich danych osobowych oraz prawo do cofnięcia zgody. Możesz wykonać te prawa poprzez ustawienia w aplikacji lub kontaktując się z naszym zespołem wsparcia.',
      },
      security: {
        title: 'Bezpieczeństwo',
        content: 'Stosujemy szyfrowanie i środki bezpieczeństwa zgodne ze standardami branżowymi w celu ochrony Twoich danych, w tym szyfrowaną transmisję SSL, szyfrowane przechowywanie danych i kontrolę dostępu. Regularnie przeglądamy i aktualizujemy nasze środki bezpieczeństwa.',
      },
    },
  },
  terms: {
    title: 'Warunki usługi',
    sections: {
      acceptance: {
        title: 'Akceptacja warunków',
        content: 'Korzystając z tej aplikacji, akceptujesz niniejsze warunki usługi. Jeśli nie zgadzasz się z którąkolwiek częścią tych warunków, prosimy o zaprzestanie korzystania z aplikacji. Zastrzegamy sobie prawo do zmiany tych warunków w dowolnym momencie.',
      },
      service: {
        title: 'Opis usługi',
        content: 'ElderCare zapewnia wsparcie w zarządzaniu zdrowiem, w tym rejestrację danych zdrowotnych, przypomnienia o lekach, wezwania pomocy i inne funkcje. Usługa ta ma charakter wyłącznie informacyjny i nie stanowi porady medycznej, ani nie może zastąpić profesjonalnych usług medycznych.',
      },
      accounts: {
        title: 'Zarządzanie kontem',
        content: 'Aby korzystać z podstawowych funkcji tej aplikacji, należy zarejestrować konto. Jesteś odpowiedzialny za bezpieczeństwo swojego hasła i wszelkie działania na swoim koncie. W przypadku wykrycia nieautoryzowanego użycia konta, prosimy o natychmiastowe powiadomienie nas.',
      },
      data: {
        title: 'Dane i prywatność',
        content: 'Cenimy ochronę Twojej prywatności. Szczegółowe zasady przetwarzania danych znajdują się w naszej Polityce prywatności. Zachowujesz pełną kontrolę nad przesyłanymi danymi zdrowotnymi.',
      },
      liability: {
        title: 'Ograniczenie odpowiedzialności',
        content: 'Informacje zdrowotne dostarczane przez tę aplikację mają charakter wyłącznie informacyjny i nie stanowią diagnozy medycznej ani porady dotyczącej leczenia. Nie ponosimy odpowiedzialności za straty wynikające z korzystania z informacji tej aplikacji. W przypadku problemów zdrowotnych skonsultuj się z wykwalifikowanym specjalistą medycznym.',
      },
      changes: {
        title: 'Zmiany warunków',
        content: 'Możemy okresowo aktualizować niniejsze warunki usługi. Istotne zmiany będą komunikowane poprzez powiadomienia w aplikacji lub e-mail. Dalsze korzystanie z tej aplikacji stanowi akceptację zaktualizowanych warunków.',
      },
    },
  },
  feedback: {
    title: 'Opinia',
    subtitle: 'Twoja opinia jest dla nas bardzo ważna',
    name: 'Imię',
    namePlaceholder: 'Wpisz swoje imię (opcjonalnie)',
    email: 'E-mail',
    emailPlaceholder: 'Wpisz swój e-mail',
    subject: 'Temat',
    subjectGeneral: 'Ogólna opinia',
    subjectBug: 'Zgłoszenie błędu',
    subjectFeature: 'Propozycja funkcji',
    subjectOther: 'Inne',
    message: 'Wiadomość',
    messagePlaceholder: 'Opisz szczegółowo swoją opinię...',
    submit: 'Wyślij opinię',
    submitting: 'Wysyłanie...',
    success: 'Opinia wysłana pomyślnie! Dziękujemy za wkład',
    error: 'Nie udało się wysłać opinii, spróbuj ponownie później',
  },
  verify: {
    loading: 'Weryfikacja Twojego e-maila...',
    success: 'Weryfikacja udana!',
    successDesc: 'Twój e-mail został zweryfikowany. Możesz się teraz zalogować',
    failed: 'Weryfikacja nie powiodła się',
    failedDesc: 'Link weryfikacyjny jest nieprawidłowy lub wygasł. Wyślij ponownie e-mail weryfikacyjny',
    resend: 'Wyślij ponownie e-mail weryfikacyjny',
    resending: 'Wysyłanie...',
    goLogin: 'Przejdź do logowania',
  },
  theme: {
    light: 'Jasny',
    dark: 'Ciemny',
  },
}
